export default "__VITE_ASSET__xfcw4pu2__"